const productEnumerators = {
  productStatus: [
    'Live',
    'Idea',
    'Pre-Launch',
  ],
};

export default productEnumerators;
